"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("babel-polyfill");

var _react = _interopRequireWildcard(require("react"));

var _reactTable = _interopRequireDefault(require("react-table"));

var _lodash = _interopRequireDefault(require("lodash"));

var _reactSortableHoc = require("react-sortable-hoc");

var _modalMain = _interopRequireDefault(require("./modal-main"));

var _moreButton = _interopRequireDefault(require("./more-button"));

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DataTable =
/*#__PURE__*/
function (_Component) {
  _inherits(DataTable, _Component);

  function DataTable(props) {
    var _this;

    _classCallCheck(this, DataTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DataTable).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getStatusIcon", function (status) {
      switch (status) {
        case "positive":
          return _react.default.createElement("i", {
            className: "fa fa-check-circle ".concat(_this.props.statusOptions.positive.colorClass),
            "aria-hidden": "true"
          });

        case "warning":
          return _react.default.createElement("i", {
            className: "fa fa-exclamation-circle ".concat(_this.props.statusOptions.warning.colorClass),
            "aria-hidden": "true"
          });

        case "negative":
          return _react.default.createElement("i", {
            className: "fa fa-times-circle ".concat(_this.props.statusOptions.negative.colorClass),
            "aria-hidden": "true"
          });

        case "inProgress":
          return _react.default.createElement("i", {
            className: "fa fa-clock-o ".concat(_this.props.statusOptions.inProgress.colorClass),
            "aria-hidden": "true"
          });

        case "launch":
          return _react.default.createElement("i", {
            className: "fa fa-rocket ".concat(_this.props.statusOptions.launch.colorClass),
            "aria-hidden": "true"
          });

        case "pencil":
          return _react.default.createElement("i", {
            className: "fa fa-pencil ".concat(_this.props.statusOptions.pencil.colorClass),
            "aria-hidden": "true"
          });

        case "thumbsUp":
          return _react.default.createElement("i", {
            className: "fa fa-thumbs-up ".concat(_this.props.statusOptions.thumbsUp.colorClass),
            "aria-hidden": "true"
          });

        case "thumbsDown":
          return _react.default.createElement("i", {
            className: "fa fa-thumbs-down ".concat(_this.props.statusOptions.thumbsDown.colorClass),
            "aria-hidden": "true"
          });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getColumnHeader", function (rowInfo, headerTxt) {
      return _react.default.createElement("div", {
        className: "data-table-inline"
      }, _react.default.createElement("span", null, headerTxt), _react.default.createElement("i", {
        className: "fa fa-sort",
        "aria-hidden": "true"
      }));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderEditable", function (cellInfo) {
      var data = _toConsumableArray(_this.state.data);

      return _react.default.createElement("div", null, _this.props.isEditable ? _react.default.createElement("div", null, cellInfo.original.parentNode != null ? _react.default.createElement("div", {
        "data-tip": _this.state.data[cellInfo.original.parentNode].children[cellInfo.index][cellInfo.column.id],
        className: "data-table-pointer",
        contentEditable: true,
        suppressContentEditableWarning: true,
        onFocus: function onFocus(e) {
          e.target.classList.add("text-box");
        },
        onBlur: function onBlur(e) {
          data[cellInfo.original.parentNode].children[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
          e.target.classList.remove("text-box");

          _this.setState({
            data: data
          });
        },
        dangerouslySetInnerHTML: {
          __html: _this.state.data[cellInfo.original.parentNode].children[cellInfo.index][cellInfo.column.id]
        }
      }) : _react.default.createElement("div", {
        "data-tip": _this.state.data[cellInfo.index][cellInfo.column.id],
        className: "data-table-pointer",
        contentEditable: true,
        suppressContentEditableWarning: true,
        onFocus: function onFocus(e) {
          e.target.classList.add("text-box");
        },
        onBlur: function onBlur(e) {
          data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
          e.target.classList.remove("text-box");

          _this.setState({
            data: data
          });
        },
        dangerouslySetInnerHTML: {
          __html: _this.state.data[cellInfo.index][cellInfo.column.id]
        }
      })) : _react.default.createElement("div", null, cellInfo.original.parentNode != null ? data[cellInfo.original.parentNode].children[cellInfo.index][cellInfo.column.id] : data[cellInfo.index][cellInfo.column.id]));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "focusTableSelect", function (event) {
      event.target.classList.remove("select-box");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "blurTableSelect", function (event) {
      event.target.classList.add("select-box");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderSelectEditable", function (cellInfo) {
      var options;
      var column;
      var value;
      var isParent = false;

      if (cellInfo.original.parentNode != null) {
        column = _this.props.subColumns.filter(function (x) {
          return x.accessor == cellInfo.column.id;
        });
        options = column[0].editOptions;
        value = _this.state.data[cellInfo.original.parentNode].children[cellInfo.index][cellInfo.column.id];
      } else {
        column = _this.props.columns.filter(function (x) {
          return x.accessor == cellInfo.column.id;
        });
        options = column[0].editOptions;
        isParent = true;
        value = _this.state.data[cellInfo.index][cellInfo.column.id];
      }

      return _react.default.createElement("div", {
        "data-tip": value
      }, _this.props.isEditable ? _react.default.createElement("select", {
        name: "name-" + cellInfo.index + "-" + cellInfo.column.id,
        className: "select-box",
        value: value,
        onChange: function onChange(event) {
          return _this.handleDataTableSelect(cellInfo, event);
        },
        onFocus: _this.focusTableSelect,
        onBlur: _this.blurTableSelect
      }, _react.default.createElement("option", {
        key: cellInfo.index,
        value: value
      }, value), options.map(function (option, index) {
        return value != option ? _react.default.createElement("option", {
          key: "option-".concat(index),
          value: option
        }, option) : '';
      })) : _react.default.createElement("div", null, cellInfo.original.parentNode != null ? _this.state.data[cellInfo.original.parentNode].children[cellInfo.index][cellInfo.column.id] : _this.state.data[cellInfo.index][cellInfo.column.id]));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDataTableSelect", function (cellInfo, event) {
      var dataObj = _this.state.data;

      if (cellInfo.original.parentNode != null) {
        dataObj[cellInfo.original.parentNode].children[cellInfo.index][cellInfo.column.id] = event.target.value;
      } else {
        dataObj[cellInfo.index][cellInfo.column.id] = event.target.value;
      }

      _this.setState({
        data: dataObj
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "translateStatus", function (status) {
      switch (status) {
        case "positive":
          return _this.props.statusOptions.positive.text;

        case "warning":
          return _this.props.statusOptions.warning.text;

        case "negative":
          return _this.props.statusOptions.negative.text;

        case "inProgress":
          return _this.props.statusOptions.inProgress.text;

        case "launch":
          return _this.props.statusOptions.launch.text;

        case "pencil":
          return _this.props.statusOptions.pencil.text;

        case "thumbsUp":
          return _this.props.statusOptions.thumbsUp.text;

        case "thumbsDown":
          return _this.props.statusOptions.thumbsDown.text;
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "logSelection", function () {
      console.log("Logging selection.....");
      console.log(_this.state.selected);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateSelectAll", function () {
      if (_this.state.selected.length === 0) {
        _this.setState({
          selectAll: 0
        }, function () {
          var table = document.getElementsByClassName(_this.props.tableName);
          var checkboxRows = table.length > 0 ? table[0].getElementsByClassName('rt-tr-group') : document.getElementsByClassName('rt-tr-group');

          for (var i = 0; i < checkboxRows.length; i++) {
            if (checkboxRows[i].classList.contains('-selected')) checkboxRows[i].classList.remove('-selected');
          }
        });
      } else {
        if (_this.state.data !== null) {
          if (_this.state.selected.length === _this.state.data.length) {
            _this.setState({
              selectAll: 1
            });
          } else {
            _this.setState({
              selectAll: 2
            });
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "addSingleSelect", function (event, original) {
      _this.setState({
        singleSelected: original,
        selected: [original],
        selectedRadio: 'radio' + original.id
      });

      var table = document.getElementsByClassName(_this.props.tableName);
      var checkboxRows = table.length > 0 ? table[0].getElementsByClassName('rt-tr-group') : document.getElementsByClassName('rt-tr-group');

      for (var i = 0; i < checkboxRows.length; i++) {
        checkboxRows[i].classList.remove('-selected');
      }

      var parent = event.target.parentNode.parentNode.parentNode;

      if (event.target.checked) {
        parent.classList.add("-selected");
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggleRow", function (event, original) {
      if (event.target.checked) {
        _this.setState({
          selected: _toConsumableArray(_this.state.selected).concat([original])
        }, function () {
          if (original.parentNode == null) {
            _this.updateSelectAll();
          }
        });
      } else {
        for (var i = 0; i < _this.state.selected.length; i++) {
          if (original.id == _this.state.selected[i].id) {
            _this.state.selected.splice(i, 1);
          }
        }

        _this.setState({
          selected: _this.state.selected
        }, function () {
          if (original.parentNode == null) {
            _this.updateSelectAll();
          }
        });
      }

      var parent = event.target.parentNode.parentNode.parentNode;

      if (event.target.checked) {
        parent.classList.add("-selected");
      } else {
        parent.classList.remove("-selected");
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "toggleSelectAll", function () {
      var table = document.getElementsByClassName(_this.props.tableName);
      var checkboxRows = table.length > 0 ? table[0].getElementsByClassName('rt-tr-group') : document.getElementsByClassName('rt-tr-group');

      if (_this.state.selectAll !== 1) {
        for (var i = 0; i < checkboxRows.length; i++) {
          if (!checkboxRows[i].classList.contains('-selected')) checkboxRows[i].classList.add('-selected');
        }

        var expanded = _this.state.currentExpanded;

        var dataCopy = _this.state.data.slice();

        if (expanded && expanded.isExpanded) {
          var data = _this.state.data.slice();

          for (var _i = 0; _i < _this.state.data[expanded.row[0]].children.length; _i++) {
            data.push(_this.state.data[expanded.row[0]].children[_i]);
          }

          _this.setState({
            selected: data
          });
        } else {
          _this.setState({
            selected: dataCopy
          });
        }
      } else {
        for (var _i2 = 0; _i2 < checkboxRows.length; _i2++) {
          if (checkboxRows[_i2].classList.contains('-selected')) checkboxRows[_i2].classList.remove('-selected');
        }

        _this.setState({
          selected: []
        });
      }

      _this.setState({
        selectAll: _this.state.selectAll === 1 ? 0 : 1
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hideContextRibbon", function () {
      _this.setState({
        selected: [],
        singleSelected: null,
        selectedRadio: ''
      }, function () {
        _this.updateSelectAll();
      });

      var table = document.getElementsByClassName(_this.props.tableName);
      var checkboxRows = table.length > 0 ? table[0].getElementsByClassName('rt-tr-group') : document.getElementsByClassName('rt-tr-group');

      for (var i = 0; i < checkboxRows.length; i++) {
        if (_this.props.isExpandable) {
          checkboxRows[i].childNodes[0].childNodes[1].childNodes[0].checked = false;
        } else {
          checkboxRows[i].childNodes[0].childNodes[0].childNodes[0].checked = false;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getSubComponent", function (row) {
      var columns = _this.getSubColumns(row.original.children);

      return _react.default.createElement("div", _defineProperty({
        className: "subComponent"
      }, "className", "data-table-padding"), row.original.children ? _react.default.createElement(_reactTable.default, {
        data: row.original.children,
        columns: columns,
        minRows: 1,
        sortable: _this.props.isSortable,
        resizable: _this.props.isResizable,
        className: "child-data-table",
        pageSize: row.original.children.length,
        showPagination: false
      }) : "No data");
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getSubColumns", function (data) {
      var subColumns = _this.formatColumns(_this.props.subColumns, data);

      var columns = subColumns.map(function (a) {
        return _objectSpread({}, a);
      });

      if (_this.props.isSelectable && _this.props.selectedOption === 'multiple') {
        columns = [{
          id: "checkbox",
          accessor: "",
          className: "-checkbox",
          Cell: function Cell(_ref) {
            var original = _ref.original;
            return _react.default.createElement("input", {
              type: "checkbox",
              className: "checkbox grid-checkbox",
              checked: _this.checkIfChecked(original.id),
              onChange: function onChange(event) {
                return _this.toggleRow(event, original);
              }
            });
          },
          sortable: false,
          width: 45
        }].concat(_toConsumableArray(columns));
      }

      if (_this.props.isSelectable && _this.props.selectedOption === 'single') {
        columns = [{
          id: "radio",
          accessor: "",
          className: "-checkbox",
          Cell: function Cell(_ref2) {
            var original = _ref2.original;
            return _react.default.createElement("input", {
              type: "radio",
              className: "grid-checkbox",
              name: "rowOption-".concat(_this.props.tableName),
              value: "radio" + original.id,
              onChange: function onChange(event) {
                return _this.addSingleSelect(event, original);
              }
            });
          },
          sortable: false,
          width: 45
        }].concat(_toConsumableArray(columns));
      }

      return columns;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getMainColumns", function () {
      var columns = _this.state.columns.map(function (a) {
        return _objectSpread({}, a);
      });

      if (_this.props.isSelectable && _this.props.selectedOption === 'multiple') {
        columns = [{
          id: "checkbox",
          accessor: "",
          className: "-checkbox",
          Cell: function Cell(_ref3) {
            var original = _ref3.original;
            return _react.default.createElement("input", {
              type: "checkbox",
              className: "checkbox grid-checkbox",
              checked: _this.checkIfChecked(original.id),
              onChange: function onChange(event) {
                return _this.toggleRow(event, original);
              }
            });
          },
          Header: function Header(x) {
            return _react.default.createElement("input", {
              type: "checkbox",
              className: "checkbox grid-checkbox",
              checked: _this.state.selectAll === 1,
              ref: function ref(input) {
                if (input) {
                  input.indeterminate = _this.state.selectAll === 2;
                }
              },
              onChange: function onChange() {
                return _this.toggleSelectAll();
              }
            });
          },
          sortable: false,
          width: 45
        }].concat(_toConsumableArray(columns));
      }

      if (_this.props.isSelectable && _this.props.selectedOption === 'single') {
        columns = [{
          id: "radio",
          accessor: "",
          className: "-checkbox",
          Cell: function Cell(_ref4) {
            var original = _ref4.original;
            return _react.default.createElement("input", {
              type: "radio",
              className: "grid-checkbox",
              name: "rowOption-".concat(_this.props.tableName),
              value: "radio" + original.id,
              checked: _this.checkIfChecked(original.id),
              onChange: function onChange(event) {
                return _this.addSingleSelect(event, original);
              }
            });
          },
          sortable: false,
          width: 45
        }].concat(_toConsumableArray(columns));
      }

      if (_this.props.isExpandable) {
        columns = [{
          expander: true,
          Expander: function Expander(_ref5) {
            var isExpanded = _ref5.isExpanded,
                rest = _objectWithoutProperties(_ref5, ["isExpanded"]);

            return _react.default.createElement("span", {
              className: "data-table-expander-alignment"
            }, isExpanded ? _react.default.createElement("i", {
              className: "fa fa-angle-up"
            }) : _react.default.createElement("i", {
              className: "fa fa-angle-down"
            }));
          },
          style: {
            cursor: "pointer",
            fontSize: 16,
            padding: "0",
            textAlign: "center",
            userSelect: "none"
          }
        }].concat(_toConsumableArray(columns));
      }

      if (!_this.props.hasFooter) {
        columns.forEach(function (column, index) {
          column.Footer = null;
        });
      }

      return columns;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getTableClassNames", function () {
      return _this.props.height === 'auto' ? "data-table ".concat(_this.props.tableName) : "data-table fixed-header ".concat(_this.props.tableName);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "showConfigureModal", function () {
      _this.setState({
        showConfigure: true
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hideConfigureModal", function () {
      _this.setState({
        showConfigure: false,
        tempColumns: _this.state.columns,
        tempItems: _this.state.items,
        tempCheckedItems: _this.state.checkedItems
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "rearrangeColumns", function () {
      /* Set for current browser */
      localStorage.setItem("tableColumnItems-" + _this.props.tableName, JSON.stringify(_this.state.tempItems));
      localStorage.setItem("tableCheckedItems-" + _this.props.tableName, JSON.stringify(_this.state.tempCheckedItems));

      var uncheckedArr = _this.state.tempItems.filter(function (x) {
        return !_this.state.tempCheckedItems.includes(x);
      });

      _this.state.tempColumns.forEach(function (col, index) {
        col.show = true;
      });

      _this.state.tempColumns.forEach(function (col, index) {
        uncheckedArr.forEach(function (header, i) {
          if (col.fieldHeader !== undefined && col.fieldHeader === header) col.show = false;
        });
      });

      _this.setState({
        columns: _this.state.tempColumns,
        items: _this.state.tempItems,
        checkedItems: _this.state.tempCheckedItems,
        showConfigure: false
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "showColumn", function (visible, event) {
      var li = event.target.parentNode;
      var arrItem = li.textContent;
      var arrChecked = _this.state.tempCheckedItems;

      if (visible) {
        _this.setState({
          tempCheckedItems: _toConsumableArray(arrChecked).concat([arrItem])
        });
      } else {
        _this.setState({
          tempCheckedItems: arrChecked.filter(function (e) {
            return e !== arrItem;
          })
        });
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDragEnd", function (_ref6) {
      var oldIndex = _ref6.oldIndex,
          newIndex = _ref6.newIndex;

      _this.setState({
        tempColumns: (0, _reactSortableHoc.arrayMove)(_this.state.tempColumns, oldIndex, newIndex),
        tempItems: (0, _reactSortableHoc.arrayMove)(_this.state.tempItems, oldIndex, newIndex)
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "resetColumns", function () {
      _this.setState({
        items: _this.state.initialItems,
        tempItems: _this.state.initialItems,
        checkedItems: _this.state.initialItems,
        tempCheckedItems: _this.state.initialItems,
        columns: _this.state.initialColumns,
        tempColumns: _this.state.initialColumns
      }, function () {
        _this.rearrangeColumns();
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getSelectedItems", function () {
      return _this.state.selected;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setSelectedItems", function (selected) {
      if (selected && _this.state.data) {
        for (var i = 0; i < selected.length; i++) {
          var check = true;

          for (var s = 0; s < _this.state.selected.length; s++) {
            if (_this.state.selected[s].id === _this.state.data[selected[i]].id) {
              check = false;
              break;
            }
          }

          if (check) {
            _this.state.selected.push(_this.state.data[selected[i]]);
          }
        }
      }

      _this.setState({
        selected: _this.state.selected
      });

      setTimeout(function () {
        this.highlightRows();
      }.bind(_assertThisInitialized(_assertThisInitialized(_this))), 10);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getData", function () {
      return _this.state.data;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getPage", function () {
      return _this.state.page;
    });

    _this.state = {
      /* data table */
      data: _this.props.data,
      selectAll: 0,
      columns: [],
      statusTranslations: null,
      subColumns: [],
      selected: [],
      selectedRadio: '',
      singleSelected: null,
      pageCount: _this.props.pageCount,
      page: undefined,
      expanded: {},
      currentExpanded: {},

      /* config */
      showConfigure: false,
      items: [],
      checkedItems: [],
      initialItems: [],
      initialColumns: [],
      tempItems: [],
      tempColumns: [],
      tempCheckedItems: []
    };
    return _this;
  }

  _createClass(DataTable, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data !== this.props.data) {
        this.setState({
          data: nextProps.data
        });
        setTimeout(function () {
          this.highlightRows();
        }.bind(this), 10);
      }

      if (nextProps.pageCount !== this.props.pageCount) {
        this.setState({
          pageCount: nextProps.pageCount
        });
      }

      if (nextProps.page !== this.props.page) {
        this.setState({
          page: nextProps.page
        });
      }
    }
  }, {
    key: "pageChange",
    value: function pageChange(pageIndex) {
      setTimeout(function () {
        this.highlightRows();
      }.bind(this), 10);
    }
  }, {
    key: "formatColumns",
    value: function formatColumns(columns, data) {
      var _this2 = this;

      var formattedColumns = [];

      if (columns) {
        var _loop = function _loop() {
          var header = columns[i].fieldHeader;
          var column = void 0;
          column = {
            headerClassName: columns[i].headerClassName,
            className: columns[i].className,
            Header: function Header(rowInfo) {
              return _this2.getColumnHeader(rowInfo, header);
            },
            accessor: columns[i].accessor,
            fieldHeader: columns[i].fieldHeader,
            show: columns[i].show
          };

          column.Cell = function (row) {
            return _react.default.createElement("span", {
              "data-tip": row.value
            }, row.value);
          };

          if (columns[i].editable) {
            if (columns[i].editType == 'text') {
              column.Cell = _this2.renderEditable;
            } else {
              column.Cell = _this2.renderSelectEditable;
            }
          }

          if (columns[i].isStatus) {
            column.Cell = function (row) {
              return _react.default.createElement("span", {
                "data-tip": _this2.translateStatus(row.value)
              }, _react.default.createElement("span", null, _this2.getStatusIcon(row.value), " "), _this2.translateStatus(row.value));
            };
          }

          if (columns[i].isLink) {
            column.Cell = function (row) {
              return _react.default.createElement("a", {
                "data-tip": row.value[0],
                href: row.value[1]
              }, row.value[0]);
            };
          }

          if (columns[i].footer) {
            column.Footer = _react.default.createElement("div", null, _react.default.createElement("span", {
              className: "level"
            }, columns[i].footer.label), columns[i].footer.type == "sum" ? _react.default.createElement("span", {
              className: "data"
            }, _lodash.default.round(_lodash.default.sum(_lodash.default.map(data, columns[i].accessor)))) : _react.default.createElement("span", {
              className: "data"
            }, _lodash.default.round(_lodash.default.mean(_lodash.default.map(data, columns[i].accessor)))));
          }

          formattedColumns.push(column);
        };

        for (var i = 0; i < columns.length; i++) {
          _loop();
        }
      }

      return formattedColumns;
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this3 = this;

      var columns = this.formatColumns(this.props.columns, this.props.data);
      /* Set Data & columns */

      this.setState({
        columns: columns,
        tempColumns: columns
      }, function () {
        /* config */
        var newArr = [];

        _this3.state.columns.forEach(function (obj, index) {
          newArr = _toConsumableArray(newArr).concat([obj.fieldHeader]);
        });

        _this3.setState({
          items: newArr,
          tempItems: newArr,
          checkedItems: newArr,
          tempCheckedItems: newArr,
          initialItems: newArr,
          initialColumns: _this3.state.columns
        }, function () {
          var savedColumnItems = localStorage.getItem("tableColumnItems-" + _this3.props.tableName);
          var savedCheckedItems = localStorage.getItem("tableCheckedItems-" + _this3.props.tableName);

          var newCols = _this3.state.initialColumns.map(function (a) {
            return _objectSpread({}, a);
          });

          var newItems = JSON.parse(savedColumnItems);

          if (savedColumnItems !== null) {
            var newIndex = 0;
            newCols.forEach(function (col, index) {
              if (col.fieldHeader !== undefined) {
                newIndex = newItems.indexOf(col.fieldHeader);
                newCols[index] = newCols.splice(newIndex, 1, col)[0];
              }
            });

            _this3.setState({
              columns: _toConsumableArray(newCols),
              tempColumns: _toConsumableArray(newCols),
              items: newItems,
              tempItems: newItems
            });
          }

          if (savedCheckedItems !== null) {
            var checkedArr = new Set(JSON.parse(savedCheckedItems));

            var uncheckedArr = _this3.state.items.filter(function (x) {
              return !checkedArr.has(x);
            });

            newCols.forEach(function (col, index) {
              uncheckedArr.forEach(function (header, i) {
                if (col.fieldHeader !== undefined && col.fieldHeader === header) col.show = false;
              });
            });

            _this3.setState({
              columns: _toConsumableArray(newCols),
              tempColumns: _toConsumableArray(newCols),
              checkedItems: JSON.parse(savedCheckedItems),
              tempCheckedItems: JSON.parse(savedCheckedItems)
            });
          }
        });
      });
    }
    /* END : Component mount */

  }, {
    key: "checkSelected",
    value: function checkSelected() {
      var parent = false;
      var child = false;

      if (this.state.selected.length > 1) {
        for (var i = 0; i < this.state.selected.length; i++) {
          if (this.state.selected[i] && this.state.selected[i].parentNode != null) {
            child = true;
          } else {
            parent = true;
          }
        }

        if (parent && !child) {
          return "parent";
        } else if (!parent && child) {
          return "child";
        } else if (parent && child) {
          return "both";
        }
      } else {
        if (this.state.selected[0] && this.state.selected[0].parentNode != null) {
          return "child";
        } else {
          return "parent";
        }
      }
    }
  }, {
    key: "checkIfChecked",
    value: function checkIfChecked(id) {
      for (var i = 0; i < this.state.selected.length; i++) {
        if (id == this.state.selected[i].id) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "handleRowExpanded",
    value: function handleRowExpanded(newExpanded, index, event) {
      this.setState({
        currentExpanded: {
          row: index,
          isExpanded: !this.state.expanded[index]
        },
        expanded: _defineProperty({}, index, !this.state.expanded[index])
      });
    }
  }, {
    key: "highlightRows",
    value: function highlightRows() {
      var table = document.getElementsByClassName(this.props.tableName);
      var checkboxRows = table.length > 0 ? table[0].getElementsByClassName('rt-tr-group') : document.getElementsByClassName('rt-tr-group');

      for (var i = 0; i < checkboxRows.length; i++) {
        var isChecked = false;

        if (this.props.isExpandable) {
          isChecked = checkboxRows[i].childNodes[0].childNodes[1].childNodes[0].checked;
        } else {
          isChecked = checkboxRows[i].childNodes[0].childNodes[0].childNodes[0].checked;
        }

        if (isChecked) {
          checkboxRows[i].classList.add('-selected');
        } else {
          checkboxRows[i].classList.remove('-selected');
        }
      }
    }
  }, {
    key: "resetPages",
    value: function resetPages() {
      var _this4 = this;

      this.setState({
        page: 0
      }, function () {
        _this4.setState({
          page: undefined
        });
      });
    }
    /* END : CONFIG */

  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      /* START : modifiers */
      var dataTableClass = this.getTableClassNames();
      var sortable = this.props.isSortable;
      var resizable = this.props.isResizable;
      var height = this.props.height;
      var columns = this.getMainColumns();
      /* END : modifiers */

      /* START : config columns */

      var DraggableItem = (0, _reactSortableHoc.SortableElement)(function (_ref7) {
        var value = _ref7.value;
        return _react.default.createElement("li", {
          className: "drag-list-item",
          draggable: "true"
        }, _this5.state.tempCheckedItems.includes(value) ? _react.default.createElement("button", {
          onClick: function onClick(event) {
            return _this5.showColumn(false, event);
          }
        }, _react.default.createElement("i", {
          className: "data-table-pointer-events fa fa-eye",
          "aria-hidden": "true"
        })) : _react.default.createElement("button", {
          onClick: function onClick(event) {
            return _this5.showColumn(true, event);
          }
        }, _react.default.createElement("i", {
          className: "data-table-pointer-events fa fa-eye-slash",
          "aria-hidden": "true"
        })), value, _react.default.createElement("i", {
          className: "fa fa-arrows-v",
          "aria-hidden": "true"
        }));
      });
      var DraggableList = (0, _reactSortableHoc.SortableContainer)(function (_ref8) {
        var items = _ref8.items;
        return _react.default.createElement("ul", {
          className: "drag-list"
        }, items.map(function (value, index) {
          return _react.default.createElement(DraggableItem, {
            key: "item-".concat(index),
            index: index,
            value: value
          });
        }));
      });
      return _react.default.createElement("div", null, this.state.showConfigure ? _react.default.createElement(_modalMain.default, {
        title: "Customize columns",
        primaryMethod: function primaryMethod() {
          return _this5.rearrangeColumns();
        },
        btnTitle1: "Save",
        secondaryMethod: function secondaryMethod() {
          return _this5.resetColumns();
        },
        btnTitle2: "Reset",
        modal: true,
        hideMethod: function hideMethod() {
          return _this5.hideConfigureModal();
        }
      }, _react.default.createElement(DraggableList, {
        items: this.state.tempItems,
        onSortEnd: this.onDragEnd
      })) : "", _react.default.createElement("div", {
        className: "data-table-container"
      }, _react.default.createElement("div", {
        className: this.state.selected.length > 0 ? "grid-toolbar-data-table hidden" : "grid-toolbar-data-table"
      }, _react.default.createElement("div", {
        className: "button-group table-actions",
        role: "group",
        "aria-label": "Action buttons"
      }, this.props.actions && this.props.actions.primaryAction && !this.props.actions.primaryActionIsMoreBtn ? _react.default.createElement("button", {
        type: "button",
        className: "button button-blue",
        onClick: function onClick() {
          return _this5.props.actions.primaryAction();
        }
      }, this.props.actions.primaryActionLabel) : this.props.actions && this.props.actions.primaryAction && this.props.actions.primaryActionIsMoreBtn && this.props.actions.primaryActionMoreBtn ? _react.default.createElement(_moreButton.default, {
        size: "regular",
        isPrimary: true,
        title: "More"
      }, _react.default.createElement("ul", null, this.props.actions.primaryActionMoreBtn.map(function (action, index) {
        return _react.default.createElement("li", {
          key: index
        }, _react.default.createElement("a", {
          onClick: function onClick() {
            return action.action();
          }
        }, action.label));
      }))) : "", this.props.actions && this.props.actions.secondaryActions ? this.props.actions.secondaryActions.map(function (action, index) {
        return action.isMoreBtn ? _react.default.createElement(_moreButton.default, {
          size: "regular",
          isPrimary: false,
          title: "More"
        }, _react.default.createElement("ul", null, action.moreBtnActions.map(function (moreAction, index) {
          return _react.default.createElement("li", {
            key: index
          }, _react.default.createElement("a", {
            onClick: function onClick() {
              return moreAction.action();
            }
          }, moreAction.label));
        }))) : _react.default.createElement("button", {
          key: index,
          type: "button",
          className: "button button-transparent",
          onClick: function onClick() {
            return action.action();
          }
        }, action.label);
      }) : ""), _react.default.createElement("div", {
        className: this.props.showColumnOptions ? "pagination-wrapper" : "pagination-wrapper hidden"
      }, _react.default.createElement("ul", {
        className: "pagination"
      }, _react.default.createElement("li", null, _react.default.createElement("button", {
        type: "button",
        className: "next-page button button-transparent",
        onClick: this.showConfigureModal
      }, _react.default.createElement("i", {
        className: "fa fa-cog",
        "aria-hidden": "true"
      })))), "`")), this.state.selected.length > 0 ? _react.default.createElement("div", {
        className: "grid-toolbar context-ribbon-extra"
      }, _react.default.createElement("div", {
        className: "button-group context-left context-buttons",
        role: "group",
        "aria-label": "Action buttons"
      }, this.checkSelected() == "child" ? this.props.actions && this.props.actions.childContextualActions ? this.props.actions.childContextualActions.map(function (action, index) {
        return action.isMoreBtn ? _react.default.createElement(_moreButton.default, {
          size: "regular",
          isPrimary: false,
          title: "More"
        }, _react.default.createElement("ul", null, action.moreBtnActions.map(function (moreAction, index) {
          return _react.default.createElement("li", {
            key: index
          }, _react.default.createElement("a", {
            onClick: function onClick() {
              return moreAction.action();
            }
          }, moreAction.label));
        }))) : _react.default.createElement("button", {
          key: index,
          type: "button",
          className: "button button-context",
          onClick: function onClick() {
            return action.action();
          }
        }, action.label);
      }) : "" : "", this.checkSelected() == "parent" ? this.props.actions && this.props.actions.parentContextualActions ? this.props.actions.parentContextualActions.map(function (action, index) {
        return action.isMoreBtn ? _react.default.createElement(_moreButton.default, {
          size: "regular",
          isPrimary: false,
          title: "More"
        }, _react.default.createElement("ul", null, action.moreBtnActions.map(function (moreAction, index) {
          return _react.default.createElement("li", {
            key: index
          }, _react.default.createElement("a", {
            onClick: function onClick() {
              return moreAction.action();
            }
          }, moreAction.label));
        }))) : _react.default.createElement("button", {
          key: index,
          type: "button",
          className: "button button-context",
          onClick: function onClick() {
            return action.action();
          }
        }, action.label);
      }) : "" : "", this.checkSelected() == "both" ? this.props.actions && this.props.actions.contextualActions ? this.props.actions.contextualActions.map(function (action, index) {
        return action.isMoreBtn ? _react.default.createElement(_moreButton.default, {
          size: "regular",
          isPrimary: false,
          title: "More"
        }, _react.default.createElement("ul", null, action.moreBtnActions.map(function (moreAction, index) {
          return _react.default.createElement("li", {
            key: index
          }, _react.default.createElement("a", {
            onClick: function onClick() {
              return moreAction.action();
            }
          }, moreAction.label));
        }))) : _react.default.createElement("button", {
          key: index,
          type: "button",
          className: "button button-context",
          onClick: function onClick() {
            return action.action();
          }
        }, action.label);
      }) : "" : ""), _react.default.createElement("div", {
        className: "context-right"
      }, _react.default.createElement("span", {
        className: "selected-count"
      }, this.state.selected.length, " selected"), _react.default.createElement("button", {
        type: "button",
        className: "button button-context",
        onClick: this.hideContextRibbon
      }, "Cancel"))) : "", _react.default.createElement(_reactTable.default, {
        data: this.state.data,
        columns: columns,
        minRows: 1,
        expanded: this.state.expanded,
        onExpandedChange: function onExpandedChange(newExpanded, index, event) {
          return _this5.handleRowExpanded(newExpanded, index, event);
        },
        manual: this.props.manualPagination,
        pages: this.state.pageCount,
        onFetchData: this.props.fetchData,
        showPagination: this.props.showPagination,
        defaultPageSize: 10,
        page: this.state.page,
        ref: function ref(table) {
          _this5.table = table;
        },
        sortable: sortable,
        onPageChange: function onPageChange(pageIndex) {
          return _this5.pageChange(pageIndex);
        },
        resizable: resizable,
        className: dataTableClass,
        SubComponent: this.props.isExpandable ? function (row) {
          return _this5.getSubComponent(row);
        } : null,
        style: {
          height: height
        }
      })), _react.default.createElement(_reactTooltip.default, {
        place: "top",
        type: "dark",
        effect: "float",
        delayShow: 1000
      }));
    }
  }]);

  return DataTable;
}(_react.Component);

var _default = DataTable;
exports.default = _default;